export const FOLDER_NAME = 'ResyCredit';
export const FILE_NAME = 'ResyCreditData.json';
export const FILE_NAME_REFRESH = 'ResyCreditDataRefresh.json';

export const CONTEXT = 'Resy Credit page';
export const CATEGORY = 'Resy Credit Interaction';

export const RESYCREDIT_GOLD_URL = '/resycredit/amexgold';
export const RESYCREDIT_DELTA_RESERVE_URL = '/resycredit/deltaskymilesreserve';
export const RESYCREDIT_DELTA_PLATINUM_URL = '/resycredit/deltaskymilesplatinum';
export const RESYCREDIT_AMEX_PLATINUM_URL = '/resycredit/platinumcard';

export const CARD_TYPES = {
  GOLD: 'GOLD',
  DELTARESERVE: 'DELTARESERVE',
  DELTAPLATINUM: 'DELTAPLATINUM',
  AMEXPLATINUM: 'AMEXPLATINUM',
};
